// Establishes a serial connection: shows a pop up to manually pick a device
// unless isAutomatic is true, in which case existing ports are used directly.
import axios from 'axios'
import { zingFreeFallSendBytes } from '../../utils/freeFallBytes'
import {
    getVersion,
    getS3Version,
} from '../ReusableComponents/ByteTransfer/getVersion'
import { _0PORT } from '../flowchart_port/FlowchartConnections/Myflowchart/PortTypes'
import {
    checkAndUpdateMetaYaml,
    getMountPoint,
} from '../../utils/readWriteFile'
import { checkFirmwareVersion } from '../../utils/firmwareUpdateFlow'
import {
    getVersionObjNameKey,
    getRequiredFirmwareMin,
} from '../../utils/verionControl'
import { getPeeCeeVariantLabel } from '../../hooks/useBrandConfig'
import { Transport } from '../FirmwareJS/webserial'
import { ESPLoader } from '../FirmwareJS/ESPLoader'
import {
    USB_PRODUCT_IDS,
    SERIAL_PORT_FILTERS,
    deviceMatchesPid,
} from '../../utils/usbDeviceIds'
const DEVICES = [
    {
        name: 'PeeCeeTed',
        id: 'Ace',
        version: '0.1.13',
        usbProductId: USB_PRODUCT_IDS.CH340_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.CH340_SERIAL],
        src: 'PC',
    },
    {
        name: 'Crawlee',
        id: 'Hexapod',
        version: '1.0.01',
        usbProductId: USB_PRODUCT_IDS.CH340_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.CH340_SERIAL],
        src: 'Hexapod',
    },
    {
        name: 'Zing',
        id: 'Humanoid',
        version: '1.0.01',
        usbProductId: USB_PRODUCT_IDS.CH340_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.CH340_SERIAL],
        src: 'Zing',
    },
    {
        name: 'Zing',
        id: 'Humanoid',
        version: '0.1.10',
        usbProductId: USB_PRODUCT_IDS.CH340_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.CH340_SERIAL],
        src: 'Zing',
    },
    {
        name: 'PeeCeeTed',
        id: 'Ace',
        version: '1.0.04',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL],
        src: 'PCv1',
    },
    {
        name: 'Roboki',
        id: 'Roboki',
        version: '1.0.1',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL],
        src: 'Roboki',
    },
    {
        name: 'Autoki',
        id: 'Autoki',
        version: '1.0.2',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL],
        src: 'autoki',
    },
    {
        name: 'Crawlee',
        id: 'Hexapod',
        version: '2.0.01',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [
            USB_PRODUCT_IDS.ESP32_S_SERIAL,
            USB_PRODUCT_IDS.CRAWLEE,
        ],
        src: 'Hexapod',
    },
    {
        name: 'Crawlee',
        id: 'Hexapod',
        version: '3.0.01',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [
            USB_PRODUCT_IDS.ESP32_S_SERIAL,
            USB_PRODUCT_IDS.CRAWLEE,
        ],
        src: 'Hexapod',
    },
    {
        name: 'Zing',
        id: 'Humanoid',
        version: '2.0.0',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL, USB_PRODUCT_IDS.ZING],
        src: 'Zing',
    },
    {
        name: 'Zing',
        id: 'Humanoid',
        version: '2.2.0',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL, USB_PRODUCT_IDS.ZING],
        src: 'Zing',
    },
    {
        name: 'Zing',
        id: 'Humanoid',
        version: '3.0.01',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL, USB_PRODUCT_IDS.ZING],
        src: 'Zing',
    },
    {
        name: 'Klaw',
        id: 'Klaw',
        version: '1.0.01',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL, USB_PRODUCT_IDS.KLAW],
        src: 'Klaw',
    },
    {
        name: 'Atr',
        id: 'Atr',
        version: '1.0.1',
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
        usbProductIds: [USB_PRODUCT_IDS.ESP32_S_SERIAL],
        src: 'Atr',
    },
    {
        name: 'Toki',
        id: 'Toki',
        version: '1.0.1',
        usbProductId: USB_PRODUCT_IDS.CH340_8040,
        usbProductIds: [USB_PRODUCT_IDS.CH340_8040, USB_PRODUCT_IDS.TOKI],
        src: 'Toki',
    },
    {
        name: 'Poki',
        id: 'Poki',
        version: '1.0.1',
        usbProductId: USB_PRODUCT_IDS.CH340_8040,
        usbProductIds: [USB_PRODUCT_IDS.CH340_8040, USB_PRODUCT_IDS.POKI],
        src: 'poki',
    },
    {
        name: 'Moki',
        id: 'Moki',
        version: '1.0.1',
        usbProductId: USB_PRODUCT_IDS.CH340_8040,
        usbProductIds: [USB_PRODUCT_IDS.CH340_8040],
        src: 'Moki',
    },
]
const filters = SERIAL_PORT_FILTERS

const sendCONFBytes = async (worker) => {
    try {
        sessionStorage.removeItem('peeCeeConfVersion')
        let getWorkerdata = false
        let isMemoryPresent = false
        let isArmError = false
        let is2In1Sensor = false
        worker.postMessage({
            type: 'WriteArrayFormat1310',
            value: [
                'C'.charCodeAt(0),
                'O'.charCodeAt(0),
                'N'.charCodeAt(0),
                'F'.charCodeAt(0),
            ],
        })

        worker.onmessage = (e) => {
            const regex = /^CF.*ER$/

            if (
                e.data.type == 'actionRead' &&
                regex.test(e.data.value.stringData)
            ) {
                isMemoryPresent = e.data.value.arrayData?.[3] === 1
                getWorkerdata = true

                const confByte = e.data.value.arrayData?.[2]
                if (confByte === 1 || confByte === 2) {
                    sessionStorage.setItem(
                        'peeCeeConfVersion',
                        String(confByte)
                    )
                }

                // Enable/disable free fall for Zing 2.0 based on the current page
                let pathname = window.location.pathname
                const isTargetPath = [
                    '/remote-humanoid',
                    '/introduction',
                    '/speak',
                    '/music',
                    '/camera',
                ].includes(pathname)
                const freeFallValue = e.data.value.arrayData?.[4]
                if (
                    (freeFallValue === 0 && isTargetPath) ||
                    (freeFallValue === 1 && !isTargetPath)
                ) {
                    zingFreeFallSendBytes({
                        worker,
                        value: freeFallValue === 0 ? 1 : 0,
                    })
                }
                if (e.data.value.arrayData?.[5] == 1) {
                    isArmError = true
                }
                if (e.data.value.arrayData?.[2] == 2) {
                    is2In1Sensor = true
                }
            }

            getWorkerdata = true
        }

        let timeOutVariable = setTimeout(() => {
            if (!sessionStorage.getItem('peeCeeConfVersion')) {
                sessionStorage.setItem('peeCeeConfVersion', '1')
            }
            getWorkerdata = true
        }, 2000)
        while (!getWorkerdata) {
            await new Promise((reslove) => setTimeout(reslove, 100))
        }
        clearTimeout(timeOutVariable)
        if (!sessionStorage.getItem('peeCeeConfVersion')) {
            sessionStorage.setItem('peeCeeConfVersion', '1')
        }
        return { isMemoryPresent, isArmError, is2In1Sensor }
    } catch (e) {
        console.error(e)
        if (!sessionStorage.getItem('peeCeeConfVersion')) {
            sessionStorage.setItem('peeCeeConfVersion', '1')
        }
        return { isMemoryPresent: true, isArmError: false, is2In1Sensor: false }
    }
}

export const connectSerialDeviceInitial = async (
    { isAutomatic = false },
    worker,
    socketData,
    callbacks = {}
) => {
    try {
        if (sessionStorage.getItem('firmwareUpdateInProgress') === 'true') {
            console.warn(
                'Firmware update in progress. Skipping connection flow.'
            )
            return {
                isPortOpen: false,
                firmwareUpdateInProgress: true,
                isMemoryPresent: false,
                isArmError: false,
                mountPoint: null,
            }
        }

        const port = await acquirePort(isAutomatic)
        if (!port) return null

        const pid = port.getInfo().usbProductId
        const matchedDevice = DEVICES.find((obj) => deviceMatchesPid(obj, pid))
        sessionStorage.setItem(
            'matchedDevices',
            JSON.stringify([matchedDevice])
        )

        const isWorkerConnected = await manageWorkerConnection(
            worker,
            'connect',
            {
                pid,
                matchedDevice,
            }
        )

        if (!isWorkerConnected) {
            console.error('Final worker handshake failed.')
            alert('Unable to open port.')
            return
        }

        sessionStorage.setItem('user', JSON.stringify(1))

        const { Version, device, full_version } = await getS3Version(
            worker,
            pid
        )
        if (!Version) return

        if (Version === 'no data found') {
            await manageWorkerConnection(worker)
            return {
                isPortOpen: false,
                noVersionResponse: true,
                port,
            }
        }

        clearCustomCodeFlagOnVersion(Version)

        const deviceObj = DEVICES.find(
            (obj) =>
                Version.slice(0, 1) == obj.version.slice(0, 1) &&
                obj.id == device
        )

        // Initial hardware status check (handles Ace/I2C and Robot Memory/Arm)
        let hardwareStatus = await checkHardwareStatus(
            worker,
            deviceObj,
            Version
        )

        // Device mismatch checks must run before the firmware check, so the
        // mismatch popup appears first and the mandatory firmware update
        // dialog only shows once the user accepts the connected device.
        const allowedDeviceName = sessionStorage.getItem('allowedDevice')
        const targetDeviceName = normalizeDeviceName(
            allowedDeviceName,
            device,
            Version
        )

        if (targetDeviceName && targetDeviceName !== device) {
            const mismatchObj = createMismatchObject(
                device,
                Version,
                allowedDeviceName
            )
            return {
                isPortOpen: false,
                port,
                allowedDeviceObj: mismatchObj,
                ...hardwareStatus,
            }
        }
        const allowedPeeCeeVariant = sessionStorage.getItem(
            'allowedPeeCeeVariant'
        )
        const peeCeeConfVersion = sessionStorage.getItem('peeCeeConfVersion')
        if (device === 'Ace' && allowedPeeCeeVariant && peeCeeConfVersion) {
            const detectedVariant =
                peeCeeConfVersion === '2' ? 'ted2' : 'ted1'
            if (detectedVariant !== allowedPeeCeeVariant) {
                return {
                    isPortOpen: false,
                    port,
                    allowedDeviceObj: {
                        variantMismatch: true,
                        selected: getPeeCeeVariantLabel(allowedPeeCeeVariant),
                        detected: getPeeCeeVariantLabel(detectedVariant),
                        detectedVariantKey: detectedVariant,
                        connectedDevice: deviceObj.id,
                        detectedVersion: Version,
                    },
                    ...hardwareStatus,
                }
            }
        }

        // Callers that don't wire onFirmwareUpdateRequired (automatic
        // reconnects, deviceSelectTwo) still must never accept a device
        // whose firmware is below the supported minimum. Block it here,
        // the same way connectSerialDeviceIntermediate always does.
        if (
            !callbacks.onFirmwareUpdateRequired &&
            sessionStorage.getItem('microPython') !== 'true'
        ) {
            const minFirmwareFloor = getRequiredFirmwareMin(
                deviceObj.id,
                Version
            )
            if (minFirmwareFloor) {
                await manageWorkerConnection(worker)
                return {
                    isPortOpen: false,
                    port,
                    allowedDeviceObj: {
                        firmwareUnsupported: true,
                        minFirmware: minFirmwareFloor,
                        currentVersion: Version,
                        id: deviceObj.id,
                    },
                    ...hardwareStatus,
                }
            }
        }

        // 1. Check Firmware for ALL devices (skip if MicroPython)
        if (
            callbacks.onFirmwareUpdateRequired &&
            sessionStorage.getItem('microPython') !== 'true'
        ) {
            let check
            // PeeCee is scoped to the 1.x line (v0.1 has no 1.1.12 build);
            // Zing is scoped to the 2.2 line.
            const minFirmware = getRequiredFirmwareMin(deviceObj.id, Version)

            if (minFirmware) {
                const minCheck = await checkFirmwareVersion(
                    getVersionObjNameKey(deviceObj.id),
                    Version,
                    minFirmware.split('.').slice(0, 2).join('.')
                )
                check = {
                    ...minCheck,
                    updateAvailable: true,
                    mandatory: true,
                    latestVersion: minCheck.latestVersion || minFirmware,
                }
            } else {
                check = await checkFirmwareVersion(
                    getVersionObjNameKey(deviceObj.id),
                    Version
                )
            }

            if (check.updateAvailable) {
                const confirmed =
                    await callbacks.onFirmwareUpdateRequired(check)
                if (confirmed || check.mandatory) {
                    console.log(
                        'Update required. Disconnecting worker to release port...'
                    )
                    await manageWorkerConnection(worker)
                    return {
                        isPortOpen: false,
                        firmwareUpdateRequired: true,
                        firmwareCheck: check,
                    }
                }
            }
        }

        // 2. Advanced updates (Assets) for specific devices
        // NOTE: 'Humanoid' (Zing) is intentionally excluded. Firmware handles action
        // files internally. Re-add 'Humanoid' below when the feature is re-enabled.
        if (
            ['Hexapod'].includes(deviceObj.id) &&
            ['2', '3'].includes(Version?.[0])
        ) {
            const updateStatus = await handleAdvancedDeviceUpdates(
                {
                    deviceObj,
                    Version,
                    full_version,
                    socketData,
                },
                callbacks
            )

            if (updateStatus?.mountPoint) {
                hardwareStatus.mountPoint = updateStatus.mountPoint
            }
        }

        const finalDeviceName =
            allowedDeviceName === 'Autoki' && deviceObj.id === 'Roboki'
                ? 'Autoki'
                : deviceObj.id
        sessionStorage.setItem('connectedDevice', finalDeviceName)
        sessionStorage.setItem('deviceVersion', Version)

        const isMicroPython = sessionStorage.getItem('microPython') === 'true'
        if (isMicroPython) {
            localStorage.setItem('microPythonFlashed', 'true')
        } else {
            localStorage.removeItem('microPythonFlashed')
        }

        return {
            isPortOpen: true,
            port,
            worker,
            isMicroPython,
            ...hardwareStatus,
        }
    } catch (e) {
        console.error('Connection sequence failed:', e)
        return null
    }
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

function clearCustomCodeFlagOnVersion(Version) {
    if (!Version || Version === 'no data found' || Version === 'BOOT_MODE')
        return
    localStorage.removeItem('customCodeFlashed')
}

async function acquirePort(isAutomatic) {
    if (isAutomatic) {
        const portList = await navigator.serial.getPorts({ filters })
        return portList.length > 0 ? portList[0] : null
    }
    return await navigator.serial.requestPort({ filters })
}

async function manageWorkerConnection(worker, action, payload = {}) {
    return new Promise((resolve) => {
        const handler = (e) => {
            if (e.data.type === 'connected' && action === 'connect') {
                worker.removeEventListener('message', handler)
                resolve(e.data.value)
            }
            if (e.data.type === 'disconnected') {
                worker.removeEventListener('message', handler)
                resolve(true)
            }
        }

        worker.addEventListener('message', handler)

        if (action === 'connect') {
            worker.postMessage({
                type: 'connected',
                pid: payload.pid,
                matchedObj: [payload.matchedDevice],
            })
        } else {
            worker.postMessage({ type: 'disconnected' })
        }

        // Timeout safety
        setTimeout(() => {
            worker.removeEventListener('message', handler)
            resolve(false)
        }, 3000)
    })
}

async function checkHardwareStatus(worker, deviceObj, Version) {
    const majorVersion = Version?.[0]
    const minorVersion = parseInt(Version.split('.')?.[2]) || 0
    // Ace/PeeCee versions are major.minor.patch (e.g. "1.12.02"); the CONF
    // probe needs the real minor segment, not the last (patch) segment.
    const aceMinorVersion = parseInt(Version.split('.')?.[1]) || 0

    // 1. Check for Ace (PeeCee) 2-in-1 (I2C) Sensor
    const isAceCheck = deviceObj.id === 'Ace'

    // 2. Check for Humanoid/Hexapod Memory & Arm Error
    const isRobotCheck =
        ['Humanoid', 'Hexapod'].includes(deviceObj.id) &&
        ['2', '3'].includes(majorVersion) &&
        minorVersion >= (deviceObj.id === 'Humanoid' ? 4 : 3)

    if (isAceCheck || isRobotCheck) {
        return await sendCONFBytes(worker)
    }

    // Default fallback if no check is needed (assume memory present for older robots)
    const defaultMemory =
        ['Humanoid', 'Hexapod'].includes(deviceObj.id) &&
        ['2', '3'].includes(majorVersion)

    return {
        isMemoryPresent: defaultMemory,
        isArmError: false,
        mountPoint: '',
        is2In1Sensor: false,
    }
}

function normalizeDeviceName(allowedName, currentDevice, currentVersion) {
    let target = allowedName
    // Special handling for Ace version mismatches
    if (
        allowedName &&
        currentDevice === 'Ace' &&
        allowedName.includes('Ace') &&
        allowedName.slice(-1) === currentVersion[0]
    ) {
        target = allowedName.slice(0, -1)
    }
    // Autoki reports hardware as Roboki — remap to Autoki when user selected it
    if (allowedName === 'Autoki' && currentDevice === 'Roboki') {
        return null
    }
    return target
}

function createMismatchObject(device, Version, allowedDeviceName) {
    const allowedObj = DEVICES.find((obj) => {
        if (obj.id.includes('Ace')) {
            return obj.id == device && obj.version[0] == Version[0]
        }
        return obj.id == device
    })

    let peeCeeVariant
    if (device === 'Ace') {
        const peeCeeConfVersion = sessionStorage.getItem('peeCeeConfVersion')
        peeCeeVariant = peeCeeConfVersion === '2' ? 'ted2' : 'ted1'
    }

    return {
        ...allowedObj,
        selected: allowedDeviceName,
        version: Version,
        peeCeeVariant,
    }
}

async function handleAdvancedDeviceUpdates(
    { deviceObj, Version, full_version, socketData },
    callbacks
) {
    const {
        onWebAgentRequired,
        getLatestSocket,
        onAssetUpdateConfirm,
        onFirmwareProgress,
    } = callbacks

    let mountPoint = null

    // 1. Check Assets (Meta.yaml) via Web Agent
    try {
        const folderTag = full_version.substring(0, 5)

        // Verify release tag existence
        await axios.get(
            `https://api.github.com/repos/YuduRobotics/plode-release-management/releases/tags/${folderTag}`
        )

        let currentSocket = socketData

        // Agent Connection Check
        if (!currentSocket?.isAgentConnected && onWebAgentRequired) {
            const agentConfirmed = await onWebAgentRequired()
            if (!agentConfirmed || agentConfirmed === 'cancel') return

            if (getLatestSocket) currentSocket = getLatestSocket()
        }

        if (currentSocket?.socket) {
            const deviceFolder =
                deviceObj.id === 'Humanoid'
                    ? 'zing'
                    : deviceObj.id.toLowerCase()

            const checkResult = await checkAndUpdateMetaYaml({
                socket: currentSocket.socket,
                folderTag,
                deviceFolder,
                checkOnly: true,
            })

            if (
                checkResult.success &&
                checkResult.mountFound &&
                checkResult.updateAvailable
            ) {
                const userConfirmed = onAssetUpdateConfirm
                    ? await onAssetUpdateConfirm()
                    : true

                if (userConfirmed) {
                    await checkAndUpdateMetaYaml({
                        socket: currentSocket.socket,
                        folderTag,
                        deviceFolder,
                        onProgress: onFirmwareProgress,
                        checkOnly: false,
                    })
                }
            }
        }
    } catch (err) {
        console.warn('Asset update check skipped:', err.message)
    }

    return { mountPoint }
}

export const connectSerialDeviceIntermediate = async (
    { isAutomatic = false },
    worker,
    socketData
) => {
    let port = null

    if (isAutomatic) {
        const portList = await navigator.serial.getPorts({
            filters,
        })
        if (portList.length <= 0) return null
        port = portList[0]
        console.log('port', port)
    } else port = await navigator.serial.requestPort({ filters })

    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const connectedDevice = sessionStorage.getItem('connectedDevice')

    let info = port.getInfo()
    let pid = port.getInfo().usbProductId
    if (pid) sendConnection(true)
    const matchedObj = DEVICES.filter((obj) => deviceMatchesPid(obj, pid))

    console.log('matchedobj', matchedObj, pid)

    const getConfirmation = async () => {
        return new Promise((resolve, reject) => {
            worker.postMessage({ type: 'connected', pid, matchedObj })
            worker.onmessage = (e) => {
                if (e.data.type == 'connected' && e.data.value) {
                    resolve(true)
                }
                if (e.data.type == 'connected' && !e.data.value) resolve(false)
            }
        })
    }
    const confirm = await getConfirmation()
    if (confirm) {
        var user = 1
        sessionStorage.setItem('user', JSON.stringify(user))

        const { Version, device } = await getS3Version(worker, pid)
        console.log('worker', Version)
        if (Version == 'no data found') {
            console.log('no version found')
            sessionStorage.setItem('connectedDevice', connectedDevice)
            sendConnection(false)
            return { isPortOpen: true, port }
        }
        clearCustomCodeFlagOnVersion(Version)
        console.log('Version', Version)
        let matchedObj_with_Version = DEVICES.find(
            (obj) =>
                Version.slice(0, 1) == obj.version.slice(0, 1) &&
                obj.id == device
        )
        matchedObj_with_Version = {
            ...matchedObj_with_Version,
            version: Version,
        }
        sessionStorage.setItem('manualConnection', false)

        console.log(
            'matchedObj_with_Version',
            connectedDevice,
            deviceVersion,
            matchedObj_with_Version
        )

        let isMemoryPresent = false
        let isArmError = false
        let is2In1Sensor = false
        let mountPoint = ''

        const deviceId = matchedObj_with_Version.id
        const majorVersion = Version?.[0]
        const minorVersion = Number(Version?.split('.')?.[2])
        const aceMinorVersion = Number(Version?.split('.')?.[1])

        // Firmware below the supported minimum is not allowed to proceed,
        // even when reconnecting straight from a device screen.
        const minFirmware = getRequiredFirmwareMin(deviceId, Version)

        if (minFirmware) {
            sendConnection(false)
            return {
                isPortOpen: false,
                port,
                matchedObj_with_Version: {
                    ...matchedObj_with_Version,
                    firmwareUnsupported: true,
                    minFirmware,
                    currentVersion: Version,
                },
                isMemoryPresent,
                isArmError,
                mountPoint,
                is2In1Sensor,
            }
        }

        // Ace → 2-in-1 sensor check
        if (deviceId === 'Ace') {
            ;({ is2In1Sensor } = await sendCONFBytes(worker))
        }

        const allowedPeeCeeVariant = sessionStorage.getItem(
            'allowedPeeCeeVariant'
        )
        const peeCeeConfVersion = sessionStorage.getItem('peeCeeConfVersion')
        if (deviceId === 'Ace' && allowedPeeCeeVariant && peeCeeConfVersion) {
            const detectedVariant =
                peeCeeConfVersion === '2' ? 'ted2' : 'ted1'
            if (detectedVariant !== allowedPeeCeeVariant) {
                sendConnection(false)
                return {
                    isPortOpen: false,
                    port,
                    matchedObj_with_Version: {
                        ...matchedObj_with_Version,
                        variantMismatch: true,
                        selected: getPeeCeeVariantLabel(allowedPeeCeeVariant),
                        detected: getPeeCeeVariantLabel(detectedVariant),
                        detectedVariantKey: detectedVariant,
                        connectedDevice: deviceId,
                        detectedVersion: Version,
                    },
                    isMemoryPresent,
                    isArmError,
                    mountPoint,
                    is2In1Sensor,
                }
            }
        }

        // Humanoid / Hexapod → memory & arm error check
        if (
            ['Humanoid', 'Hexapod'].includes(deviceId) &&
            ['2', '3'].includes(majorVersion)
        ) {
            const minVersion = deviceId === 'Humanoid' ? 4 : 3

            if (minorVersion >= minVersion) {
                ;({ isMemoryPresent, isArmError } = await sendCONFBytes(worker))
            } else {
                isMemoryPresent = true
            }
        }

        if (connectedDevice == 'Humanoid') {
            if (
                connectedDevice !== device ||
                Version?.slice(0, 3) !== deviceVersion?.slice(0, 3)
            ) {
                console.log('matchedObj_with_Version', matchedObj_with_Version)
                sendConnection(false)
                return {
                    isPortOpen: false,
                    port,
                    matchedObj_with_Version,
                    isMemoryPresent,
                    isArmError,
                    mountPoint,
                    is2In1Sensor,
                }
            }
        } else if (
            (connectedDevice !== device &&
                !(connectedDevice === 'Autoki' && device === 'Roboki')) ||
            Version[0] !== deviceVersion[0]
        ) {
            console.log('matchedObj_with_Version', matchedObj_with_Version)
            sendConnection(false)
            return {
                isPortOpen: false,
                port,
                matchedObj_with_Version,
                isMemoryPresent,
                isArmError,
                mountPoint,
                is2In1Sensor,
            }
        }
        if (connectedDevice == device && Version[0] == deviceVersion[0]) {
            sessionStorage.setItem('deviceVersion', Version)
        }

        const isMicroPython = sessionStorage.getItem('microPython') === 'true'
        if (isMicroPython) {
            localStorage.setItem('microPythonFlashed', 'true')
        } else {
            localStorage.removeItem('microPythonFlashed')
        }

        sendConnection(false)
        return {
            isPortOpen: true,
            port,
            isMicroPython,
            isMemoryPresent,
            isArmError,
            mountPoint,
            is2In1Sensor,
        }
    } else {
    }
}
export const connectSerialDeviceOnRefresh = async (
    { isAutomatic = false },
    worker
) => {
    const portList = await navigator.serial.getPorts({
        filters,
    })

    if (portList.length <= 0) return null

    let port = portList[0]
    let pid = port.getInfo().usbProductId
    const res = await openSerialReadComPort(port, worker, pid)
    let deviceVersion = sessionStorage.getItem('deviceVersion')
    let device = sessionStorage.getItem('connectedDevice')
    worker.postMessage({ type: 'reconnect', deviceVersion, device })
    return res
}
export const connectSerialDevice = async ({ isAutomatic = false }, worker) => {
    console.log('connected device')
    try {
        const filters = SERIAL_PORT_FILTERS

        let port = null
        if (isAutomatic) {
            const portList = await navigator.serial.getPorts({
                filters,
            })
            if (portList.length <= 0) return null
            port = portList[0]
        } else {
            port = await navigator.serial.requestPort({ filters })
        }

        return await openSerialReadComPort(port, worker)
    } catch (e) {
        console.log(e)
    }
}

export const connectUSBDevice = async ({ isAutomatic = false }) => {
    try {
        const filters = [{ vendorId: 0xb1b0, productId: 0x93c3 }]

        let port = null
        if (isAutomatic) {
            const portList = await navigator.usb.getDevices({
                filters,
            })
            console.log(portList)
            if (portList.length <= 0) return null
            port = portList[0]
        } else {
            port = await navigator.usb.requestDevice({ filters })
        }

        return await openUSBReadComPort(port)
    } catch (e) {
        console.log(e)
    }
}

// Opens the port and two-way communication with the embedded device,
// returning the port object once connected.
export const openSerialReadComPort = async (port, worker, pid = 0) => {
    try {
        console.log('web worker')
        const isOpen = await new Promise((resolve) => {
            const handler = (e) => {
                if (e.data.type === 'connected') {
                    worker.removeEventListener('message', handler)
                    resolve(e.data.value)
                }
            }
            worker.addEventListener('message', handler)
            worker.postMessage({ type: 'connected', pid })
            setTimeout(() => {
                worker.removeEventListener('message', handler)
                resolve(false)
            }, 3000)
        })

        if (!isOpen) {
            console.log('Worker could not open the serial port')
            return { isPortOpen: false, port, errMsg: 'port not writable' }
        }

        console.log('Connection established!')

        var user = 1
        sessionStorage.setItem('user', JSON.stringify(user))

        return { isPortOpen: true, port }
    } catch (e) {
        console.log(e)
        return { isPortOpen: false, port, errMsg: e.message }
    }
}

export const openUSBReadComPort = async (port) => {
    try {
        let configNumber_ = 1
        let interfaceNumber_ = 1
        await port.open()

        if (port.configuration === null)
            await port.selectConfiguration(configNumber_)
        console.log(port)
        await port.claimInterface(interfaceNumber_)

        console.log('Connection established!')

        var user = 1
        sessionStorage.setItem('user', JSON.stringify(user))

        return { isPortOpen: true, port }
    } catch (e) {
        console.log(e)
        // closeReadComPort(port)
        return { isPortOpen: false, port: null, errMsg: e.message }
    }
}

export const closeReadComPort = async (port, worker) => {
    try {
        console.log(port)
        worker.postMessage({ type: 'disconnected' })
        sessionStorage.setItem('microPython', 'false')
        console.log('Closed readComPort')
    } catch (e) {
        sessionStorage.setItem('microPython', 'false')
        console.log(e)
        await port.close()
        worker.postMessage({ type: 'disconnected' })
    }
}

const sendConnection = (val) => {
    const event = new CustomEvent('isConnecting', { detail: val })
    document.dispatchEvent(event)
}
